
import CONSTANTSVG from '@/constants/svg';
import { STRINGS } from '@/interfaces/SmartLink/General';

const IMAGES = {
    pmp: require("@/assets/Images/pmpsm.png"),
    lte: require("@/assets/Images/hcglink.png"),
    server: require("@/assets/Images/server.png"),
    solarsm: require("@/assets/Icons/solarsm.png"),
    perforadora: require("@/assets/Icons/perforadora.png"),
    apsm: require("@/assets/Icons/apsm.png"),
    apsolar: require("@/assets/Icons/apsolar.png"),
    onlysolar: require("@/assets/Icons/onlysolar.png"),
    onlypmp: require("@/assets/Icons/onlypmp.png"),
    onlyap: require("@/assets/Icons/onlyap.png"),
}

export const IMAGES_SVG: STRINGS = {
    'pmp-ap': CONSTANTSVG.pmpap,
    'pmp-sm': CONSTANTSVG.pmpsm,
    'ap movil': CONSTANTSVG.solarTrailer,
    'ap fijo': CONSTANTSVG.tower,
    'pala': CONSTANTSVG.showel,
    'camion': CONSTANTSVG.haultruck,
    'camion lte': CONSTANTSVG.haultruck,
    'lte': CONSTANTSVG.haultruck,
    'perforadora': CONSTANTSVG.driller,
    'cargador frontal': CONSTANTSVG.frontLoader,
    'tractor': CONSTANTSVG.frontLoader,
    'pila agua': CONSTANTSVG.waterTruck,
    'pipa agua': CONSTANTSVG.waterTruck,
    'ptp': CONSTANTSVG.ptp,
}

const ICONS = {
    links: require('@/assets/Icons/links.png'),
    circles: require('@/assets/Icons/circles.png'),
}

export default {
    IMAGES,
    ICONS
}